import { useCallback, useEffect, useState } from "react";
import { Image } from "../interfaces/Space";
import "../styles/layouts/imageswipe.scss";
import UseSwipe from "../hooks/UseSwipe";

type Props = {
    open?: boolean
    images: Image[]
    clickedImage: Image | undefined
    onClickImage: () => void
}

export default function ImageSwipe({ clickedImage, open, images, onClickImage }: Props) {

    const [selected, setSelected] = useState<Image | undefined>(clickedImage);
    const [selIdx, setSelIdx] = useState<number>(0);
    const [imageClasses, setImageClasses] = useState<string[][]>([]);

    useEffect(() => {
        const auxClasses = Array(images.length);
        auxClasses.fill(['image-swipe-hidden']);
        if (clickedImage) {
            const selIndex = images.reduce((prev, curr, idx) => {
                if (curr.id === clickedImage.id) {
                    auxClasses[idx] = ['image-swipe-vislble']
                    return idx;
                }
                return prev;
            }, 0)

            setImageClasses(auxClasses);
            setSelIdx(selIndex);
            setSelected(clickedImage);
        }
    }, [images, clickedImage])

    const switchImages = useCallback((direction: number, selectedIdx: number) => {
        const hiddenClass = direction < 0 ? 'image-swipe-hidden-left' : 'image-swipe-hidden-right'
        setSelected((sel: any) => {
            const auxClasses = imageClasses;
            if (auxClasses && auxClasses.length > 0) {
                for (let i = 0; i < auxClasses.length; i++) {
                    if (i === selectedIdx) {
                        auxClasses[i] = ['image-swipe-visible'];
                    } else if (i === selectedIdx - direction) {
                        auxClasses[i] = [hiddenClass];
                    } else {
                        auxClasses[i] = ['image-swipe-hidden']
                    }
                }
            }
            setImageClasses(auxClasses);
            return images[selectedIdx];
        })
    }, [imageClasses, images])

    const swipeLeft = useCallback(() => {
        setSelIdx((si) => {
            if (si <= 0) {
                return 0;
            }
            const newSi = si - 1;
            switchImages(-1, newSi)
            return newSi;
        })
    }, [switchImages])

    const swipeRight = useCallback(() => {
        setSelIdx((si) => {
            if (si >= images.length - 1) {
                return images.length - 1
            }
            const newSi = si + 1;
            switchImages(1, newSi)
            return newSi;
        })
    }, [images.length, switchImages])

    const swipeProps = UseSwipe({
        speedThreshold: 0.1,
        action: swipeLeft,
        actionB: swipeRight,
        direction: 'horizontal'
    })

    useEffect(() => {

    }, [images, selIdx])

    const getOrientationClass = (image: Image) => {
        if (image.width && image.height && image.width < image.height) {
            return 'image-swipe-vertical';
        }

        return 'image-swipe-horizontal';
    }

    return <div
        onScroll={(e) => {
            e.preventDefault()
        }}
        {...swipeProps} className="image-swipe-selected-img"
        style={{ display: open ? 'flex' : 'none' }}>

        <div className="image-swipe-arrows-container">
            <div onClick={swipeLeft}
                className={`image-swipe-arrow image-swipe-left-arrow ${selIdx === 0 ? "image-swipe-disabled" : ""}`}>
                <div></div>
            </div>
            <div onClick={onClickImage} className="image-swipe-close"></div>
            <div onClick={swipeRight}
                className={`image-swipe-arrow image-swipe-right-arrow ${selIdx === imageClasses.length - 1 ? "image-swipe-disabled" : ""}`}>
                <div></div>
            </div>
        </div>

        <div onClick={onClickImage} className="image-swipe-background">
        </div>

        <div className="image-swipe-slide-group">
            {selected && images.map((img: Image, idx: number) => {
                return <div
                    key={idx} className="image-swipe-slide-container">
                    <div className="image-swipe-arrows"></div>
                    <div className="image-swipe-img-container">
                        <img
                            className={`${imageClasses[idx].join(' ')} ${getOrientationClass(img)}`}
                            id={img.id}
                            alt='' src={img.url} />
                        <div className={`${imageClasses[idx].join(' ')} image-swipe-label`}>
                            {img.label}
                        </div>
                    </div>
                </div>
            })}
        </div>
    </div>
}